import ParamsSign from '@legos/js-security-v3/dist'
import sha256 from 'crypto-js/sha256'

const signMap: any = {
  NHPFCoreDoctorBasic_getDoctorDetail: '63ba0',
  health_cmp_biz_getDoctorInfoById: '63ba0',
  health_cmp_pageContentDiag: '63ba0',
  health_cmp_biz_pageDoctorInfo: '63ba0',
  NHPFCoreDoctorList_queryDoctorList: '093a5',
  NHPFCore_queryYellowPagesDoctorDetail: '093a5',
}
export const signVerifiy = async (config: any, locationConfig?: any) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    console.log(config, 66666);
    // 如果不存在就直接返回
    if (!(config.data.functionId in signMap)) return resolve(config)

    try {
      const ps = new ParamsSign({
        appId: signMap[config.data.functionId], //验签ID，请参考接入步骤2申请验签ID
        debug: false, //测试时开启调试，切记：上线后设置为false。
        preRequest: true,
        // eslint-disable-next-line no-dupe-keys
        // debug: true,
      })
      const body = typeof config.data.body === 'string' ? JSON.parse(config.data.body) : config.data.body;
      const { h5st } = await ps.sign({
        // ...config.data,0
        appid: config.data.appid,
        functionId: config.data.functionId,
        body: sha256(JSON.stringify(body)).toString(),
      })
      if (h5st) {
        config.data.h5st = encodeURI(h5st)
      }
    } catch (error) {
      reject(error)
      console.log('🚀 ~ file: utils.ts:66 ~ error:', error)
    }

    //指纹获取方法 文档https://joyspace.jd.com/pages/9H9zyisovlnlxTVkMwBx
    const jsToken = await new Promise((resolve, reject) => {
      try {
        (window as any).getJsToken(function (res: any) {
          const jsToken = res.jsToken
          resolve(jsToken)
        }, 0)
      } catch (error) {
        reject(error)
      }
    })
    if (jsToken) {
      config.data['x-api-eid-token'] = jsToken
    }
    resolve(config)
  })
};